import {Component, EventEmitter, Input, Output, OnChanges} from '@angular/core';
import {ProductModel} from '../models/product.model';
import * as moment from 'moment';
import {CategoryModel} from '../models/category.model';

@Component({
  selector: 'app-product-slider',
  template: `
    <div class="container height-responsive">
      <ul class="flex-row row">
        <li class="d-none d-lg-block col-lg-3 col-xl-3" *ngFor="let product of this.productstoshow">
          <app-product-card [model]="product" [productLine]="this.productLine" [categories]="this.categories" (selected)="this.selected($event)"></app-product-card>
        </li>
      </ul>
      <div style="margin: 0 auto" class="d-lg-none d-xl-none">
      <div class="flex-row row">
        <app-carousel [model]="this.productstoshow" [productLine]="this.productLine" (selected)="this.selected($event)"></app-carousel>
        </div>
      </div>
    </div>
  `,
  styles: [    `
      .flex-row {
        display: flex;
        flex-wrap: wrap;
        padding-left: 15px;
        padding-right: 15px;
      }
      .flex-row > [class*='col-'] {
        display: flex;
        flex-direction: column;
      }

      .flex-row .thumbnail,
      .flex-row .caption {
        flex-direction: column;
        display: flex;
        flex: 1 0 auto;
        height: auto;
        position: relative;
      }
      .flex-text {
        flex-grow: 1;
      }
      .flex-row img {
        min-width: 0;
        width: 100%;
      }

      @media only screen and (max-width : 480px){
        .flex-row > [class*='col-'] {
            width: 100%;
        }
        .flex-row  {
          padding-left: 0px;
          padding-right: 0px;
        }

      }

      @media only screen and (max-width : 768px){
        .height-responsive {
            height: 450px;
        }

      }    `
  ]
})
export class ProductSliderContainerComponent implements OnChanges {
  @Input() model: ProductModel[];
  @Input() productLine: string;
  @Input() categories: CategoryModel[];
  @Output() productSelected: EventEmitter<string> = new EventEmitter<string>();
  productstoshow: ProductModel[] = [];
  inpreviewmode = false;

  ngOnChanges() {
    if (window !== window.top) {
      this.inpreviewmode = true;
   }
   this.productstoshow = [];
    this.model.forEach(r => {
      if (!this.inpreviewmode) {
        if ((!r.publishon || moment(r.publishon, 'MM/DD/YYYY').isSameOrBefore(moment())) && (!r.unpublishon || moment(r.unpublishon, 'MM/DD/YYYY').isAfter(moment()))) {
          this.productstoshow.push(r);
        }
      } else {
        if (!r.unpublishon || moment(r.unpublishon, 'MM/DD/YYYY').isAfter(moment())) {
          this.productstoshow.push(r);
        }
      }
    });
  }

  selected(prodId: string) {
    this.productSelected.next(prodId);
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/containers/product-slider.container.component.ts